import { useEffect } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { useHomepageRedirect } from 'helpers/user/homepageRedirects';

interface Props extends RouteProps {
  user?: {
    isAuthenticated?: boolean;
  };
  component: React.ComponentType<any>;
}

const LoggedOutOnlyRoute: React.FC<Props> = ({
  user,
  component: Component,
  ...rest
}) => {
  const redirect = useHomepageRedirect();
  const isLoggedIn = !!user?.isAuthenticated;

  useEffect(() => {
    if (isLoggedIn) {
      redirect({ user });
    }
  }, [isLoggedIn, redirect, user]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoggedIn) {
          return <></>;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default LoggedOutOnlyRoute;
